var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "22", height: "22", viewBox: "0 0 22 22", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "download"
    ),
    React.createElement(
      "g",
      { fill: "#222", fillRule: "evenodd" },
      React.createElement("path", { d: "M8.04 21a.625.625 0 1 1 0-1.25h2.5v-1.875H4.29A1.877 1.877 0 0 1 2.417 16V7.875c0-1.035.84-1.874 1.875-1.875h2.5a.625.625 0 1 1 0 1.25h-2.5a.625.625 0 0 0-.625.625v6.25h15v-6.25a.625.625 0 0 0-.625-.625h-2.5a.625.625 0 0 1 0-1.25h2.5c1.035 0 1.874.84 1.875 1.875V16c-.001 1.035-.84 1.874-1.875 1.875h-6.25v1.875h2.5a.625.625 0 1 1 0 1.25H8.04zm-4.374-5c0 .345.28.625.625.625h13.75c.345 0 .625-.28.625-.625v-.625h-15V16z", fillRule: "nonzero" }),
      React.createElement("path", { d: "M11.166 12.25a.63.63 0 0 1-.217-.04l-.018-.006a.61.61 0 0 1-.208-.137l-2.499-2.5a.619.619 0 0 1-.183-.442c0-.167.065-.324.183-.442a.619.619 0 0 1 .442-.183c.166 0 .324.065.441.183l1.434 1.434V1.625a.625.625 0 1 1 1.25 0v8.49l1.433-1.433a.622.622 0 0 1 .883.001.619.619 0 0 1 .184.442.619.619 0 0 1-.184.442l-2.5 2.5a.636.636 0 0 1-.205.136l-.021.009a.623.623 0 0 1-.215.038z" })
    )
  );
});


// WEBPACK FOOTER //
// ./src/static/images/download.svg